import clsx from 'clsx';
import { FC } from 'react';
import { Typography, TypographyProps } from '../../typography';
import { useCardContext } from '../card-context.ts';
import classes from './card-title.module.scss';

/**
 * CardTitle is a functional component that renders a Typography element.
 * It applies an 'h3' variant and bold styling by default.
 * Additional props passed to CardTitle are spread onto the Typography component.
 */
export const Title: FC<TypographyProps> = props => {
  const { labelId } = useCardContext();
  return <Typography id={labelId} variant={'h3'} bold {...props} className={clsx(props.className, classes.root)} />;
};

Title.displayName = 'Card.Title';